export default __webpack_public_path__ + "static/media/Shendoh of Infernal Zeal.2b315dd6.jpg";